/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Bot_WriteInputs */



/**
* | output |
* | --- |
* | "Switch between shared and custom bots" |
*
* @param {Perm_Team_Bot_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_bot_write = /** @type {((inputs?: Perm_Team_Bot_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Bot_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключаться между общим и собственным ботом")
	return /** @type {LocalizedString} */ ("Switch between shared and custom bots")
});